import { SectionTitle } from "../../components/common/SectionTitle";
import { ContactForm } from "../../components/forms/ContactForm";

type ContactViewProps = {
  title: string;
  description: string;
  submitLabel: string;
};

export function ContactView({ title, description, submitLabel }: ContactViewProps) {
  return (
    <section id="contato" className="section contact">
      <SectionTitle title={title} />
      <p className="contact-copy">{description}</p>
      <ContactForm submitLabel={submitLabel} />
    </section>
  );
}
